import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    marginTop: 10,
    paddingLeft: 5,
    textAlign: 'center',
    width: 290,
  },
});
